/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import React, { useState } from 'react';
import Lottie from 'lottie-react';
import SuccessLottie from '../../config/1127-success.json';
import { useSMAppNavigator } from '@/AppNavigator/machines/pageContent';
import { useNavigate } from 'react-router-dom';
import './styles.css';
import { Button } from 'react-bootstrap';

interface IAcknowledgementProps {
  title: string;
  subTitle: string;
  paraTitle: string;
  para1?: string;
  submitBtnText?: string;
  link: string;
  onSubmit?(): void;
  linkText: string;
  confirmModalContent?: any;
  paymentSummary?: any;
  para2?: string;
  paymentId?: any;
}

export const Acknowledgement = ({
  linkText,
  link,
  para1,
  para2,
  paraTitle,
  submitBtnText,
  onSubmit,
  subTitle,
  title,
  paymentSummary,
  confirmModalContent,
  paymentId,
}: IAcknowledgementProps) => {
  const history = useNavigate();

  const navigate = useNavigate();
  const { appNavigatorSend } = useSMAppNavigator({});

  const handleCloseButtonClick = () => {
    // Handle close button click, e.g., navigate or perform other actions
    // For now, let's just log a message
    console.log('Close button clicked!');
    appNavigatorSend('TRIGGER_REFRESH', {});
    navigate(`/applications-being-processed`);
  };

  return (
    <>
      <div className="mt-5">
        <h4 className="text-center fw-bold">{title}</h4>
        <h6 className="text-center">{subTitle}</h6>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          <Lottie
            animationData={SuccessLottie}
            loop={true}
            style={{ width: '20%' }}
          />
        </div>
        <p className="text-center">
          {paymentId && `Payment ID : ${paymentId} `}
        </p>
        <h5 className="text-center mt-5 text-secondary">{paraTitle}</h5>
        <p className="text-center ">
          {para1 && para1}{' '}
          <span
            className="link-info text-decoration-underline"
            style={{ cursor: 'pointer' }}
            onClick={() => history(link)}
          >
            {linkText}
          </span>
          {para2 && para2}
        </p>

        {/* <div className="close-button-container">
          <button onClick={handleCloseButtonClick} className="close-button">
            Close
          </button>
        </div> */}
      </div>
    </>
  );
};
